<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        @click="showPostalCodeModal(0)"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
                <v-btn
                  v-if="can('delete zones')"
                  icon
                  color="red"
                  @click="deletePostalCode(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchPostalCode"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { zonesService } from '../../../utils/services/zones.service';
  import PostalCodeModal from '../../modals/Zones/PostalCodeModal.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'WarehouseUnloadDetails',
    components: { Paginator },
    props: {
      zone: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },

          { text: this.$t('fields.zipcode'), value: 'postalcode' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showPostalCodeModal(id) {
        this.showModal({
          component: PostalCodeModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('ZIP_CODE'),
            onSave: (
              form,
              error,
            ) => zonesService.saveZipCodes(this.zone.id, form)
            .then(() => {
              this.fetchPostalCode(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchPostalCode(this.pagination.page);
            }),
          },
        });
      },

      async deletePostalCode(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return zonesService.removeZipCodes(this.zone.id, id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchPostalCode(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      async fetchPostalCode(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return zonesService.getZipCodes(this.zone.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },
    },
    async created() {
      await this.fetchPostalCode();
    },
  };
</script>
